import { render, staticRenderFns } from "./goveHome.vue?vue&type=template&id=59c9b0b4&scoped=true"
import script from "./goveHome.vue?vue&type=script&lang=js"
export * from "./goveHome.vue?vue&type=script&lang=js"
import style0 from "./goveHome.vue?vue&type=style&index=0&id=59c9b0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9b0b4",
  null
  
)

export default component.exports